import callApi from '../service/callApi';
import consumerApi, { AUTH_SHAPE } from '../service/consumerApi';

export const getId8Image = (imageId) => {
  return callApi.request({
    url: `/api/id8/content/download?imageId=${imageId}`,
    method: 'GET',
    responseType: 'arraybuffer',
  });
};

export const getConsumerId8Image = (imageId) => {
  return consumerApi.post(`/api/consumer/id8/content/download`, imageId, {
    authShape: AUTH_SHAPE.PROJECT_REQUEST,
    responseType: 'arraybuffer',
  });
};

export const getSourceImage = (promptId) => {
  return callApi.request({
    url: `/api/id8/content/download/recreate/source/file?bucketId=${promptId}`,
    method: 'POST',
    responseType: 'arraybuffer',
  });
};

export const getConsumerSourceImage = (promptId) => {
  return consumerApi.post(`/api/consumer/id8/content/download/recreate/source/file?bucketId=${promptId}`, null, {
    authShape: AUTH_SHAPE.FLAT,
    responseType: 'arraybuffer',
  });
};

export const getDemoImage = (sessionId) => {
  return callApi.request({
    url: `/api/consumer/id8/demo/recreate/image?sessionId=${sessionId}`,
    method: 'GET',
    responseType: 'arraybuffer',
  });
};
